import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";

import {
  authReducer,
  languageReducer,
  breadCrumbReducer,
  currentNavPageReducer,
  sourcesTokensReducer,
  visibleSearchLayerReducer,
  appIsEmbeddedReducer,
  subMenuDirectionReducer,
  subMenuDirectionToggleReducer,
  budgetTreeReducer,
  quickBudgetSettingReducer,
  budgetSettingReducer,
  timeSheetReducer,
  timeSheetSearchWordReducer,
  taskTypesReducer,
  taskCategoryReducer,
  timeSheetTreeReducer,
  countTaskTypeReducer,
  getClientsListReducer,
  capacityPlaningCollaboratorReducer,
  capacityPlaningProductionReducer,
  clientGroupSuggestionsReducer,
  clientSuggestionsReducer,
  collaboratorSuggestionsReducer,
  TaskCategorySuggestionsReducer,
  periodUnitSuggestionsReducer,
  categoriesStatisticsReducer,
  categoriesSettingsReducer,
  periodsSuggestionsReducer,
  yearSuggestionsReducer,
  collaboratorReducer,
  periodFinancialSheetTreeReducer,
  financialSortByReducer,
  financialSearchWordReducer,
  budgetSearchWordReducer,
  calendarSettingsReducer,
  calendarTableReducer,
  synthesisTableReducer,
  zoneSuggestionsReducer,
  erpDataReducer,
  clusterSuggestionsReducer,
  businessUnitSuggestionsReducer,
  squadsSuggestionsReducer,
  clientEntitySettingReducer,
  authorizationsReducer,
  authorizationsSettingsReducer,
  parameterSettingsReducer,
  entitySuggestionsReducer,
  collaboratorFinancialReducer,
  webNotificationsReducer,
  exportFinancialSheetReducer,
  dynamicTableReducer,
  importFinancialSheetReducer,
  importClientsBudgetReducer,
  exportCapacityDossierReducer
} from "Reducers";

export const createReducer = () =>
  combineReducers({
    auth: authReducer,
    params: combineReducers({
      lng: languageReducer,
      breadCrumb: breadCrumbReducer,
      countTaskType: countTaskTypeReducer,
      currentNavPage: currentNavPageReducer,
      sourcesTokens: sourcesTokensReducer,
      visibleSearchLayer: visibleSearchLayerReducer,
      embedded: appIsEmbeddedReducer,
      subMenuDirection: subMenuDirectionReducer,
      subMenuDirectionToggle: subMenuDirectionToggleReducer
    }),
    routing: routerReducer,
    statistics: combineReducers({
      categories: categoriesStatisticsReducer
    }),
    taskTypes: combineReducers({
      list: taskTypesReducer,
      categories: taskCategoryReducer
    }),
    clients: combineReducers({
      list: getClientsListReducer,
      entitySetting: clientEntitySettingReducer,
      filter: combineReducers({
        collaborator: collaboratorSuggestionsReducer,
        squads: squadsSuggestionsReducer,
        cluster: clusterSuggestionsReducer,
        entityClientId: entitySuggestionsReducer
      }),
      importClientsBudget: importClientsBudgetReducer
    }),
    budget: combineReducers({
      tree: budgetTreeReducer,
      filter: combineReducers({
        clientGroup: clientGroupSuggestionsReducer,
        client: clientSuggestionsReducer,
        collaborator: collaboratorSuggestionsReducer,
        year: yearSuggestionsReducer,
        searchWord: budgetSearchWordReducer
      }),
      quick: quickBudgetSettingReducer,
      setting: budgetSettingReducer,
      dynamicTable: dynamicTableReducer
    }),
    timeSheet: timeSheetReducer,
    capacityPlaning: combineReducers({
      production: capacityPlaningProductionReducer,
      collaborator: capacityPlaningCollaboratorReducer,
      collaboratorFinancial: collaboratorFinancialReducer,
      exportCapacityDossier: exportCapacityDossierReducer
    }),
    timeSheetTree: combineReducers({
      tree: timeSheetTreeReducer,
      filter: combineReducers({
        clientGroup: clientGroupSuggestionsReducer,
        client: clientSuggestionsReducer,
        collaborator: collaboratorSuggestionsReducer,
        type: TaskCategorySuggestionsReducer,
        periodUnit: periodUnitSuggestionsReducer,
        periods: periodsSuggestionsReducer,
        searchWord: timeSheetSearchWordReducer
      })
    }),
    categoriesSettings: categoriesSettingsReducer,
    collaborator: collaboratorReducer,
    financialSheet: combineReducers({
      periodTree: periodFinancialSheetTreeReducer,
      periodFilter: combineReducers({
        clientGroup: clientGroupSuggestionsReducer,
        client: clientSuggestionsReducer,
        collaborator: collaboratorSuggestionsReducer,
        year: yearSuggestionsReducer,
        squads: squadsSuggestionsReducer,
        cluster: clusterSuggestionsReducer,
        businessUnit: businessUnitSuggestionsReducer,
        sortBy: financialSortByReducer,
        searchWord: financialSearchWordReducer
      }),
      exportFinancialSheet: exportFinancialSheetReducer,
      importFinancialSheet: importFinancialSheetReducer
    }),
    calendarSettings: calendarSettingsReducer,
    calendarTable: combineReducers({
      calendar: calendarTableReducer,
      synthesis: synthesisTableReducer,
      filter: combineReducers({
        collaborator: collaboratorSuggestionsReducer,
        year: yearSuggestionsReducer,
        squads: squadsSuggestionsReducer,
        zones: zoneSuggestionsReducer
      })
    }),
    erpData: combineReducers({
      data: erpDataReducer,
      filter: combineReducers({
        client: clientSuggestionsReducer,
        collaborator: collaboratorSuggestionsReducer
      })
    }),
    authorizations: authorizationsReducer,
    authorizationsSettings: authorizationsSettingsReducer,
    parameterSettings: parameterSettingsReducer,
    notifications: combineReducers({
      web: webNotificationsReducer
    })
  });



// WEBPACK FOOTER //
// ./src/store/createReducer.js